const LINE_BREAK = '\n';

export async function readNdjson<Message>(response: Response, onMessage: (message: Message) => void): Promise<void> {
  if (!response.body) {
    return;
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffered = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) {
      return;
    }
    buffered += decoder.decode(value, { stream: true });
    const lines = buffered.split(LINE_BREAK);
    buffered = lines.pop() ?? '';
    lines.filter(Boolean).forEach((line) => onMessage(JSON.parse(line) as Message));
  }
}

export async function readErrorMessage(response: Response, fallback: string): Promise<string> {
  const body = (await response.json().catch(() => null)) as { message?: string } | null;
  return body?.message ?? `${fallback} (${response.status})`;
}
